var $ = require('jquery');
var Storage = require('../common/storage');

function WrFilter() {
	return {
		queryvalue: '%',
		queryfield: 'surname',
		wildcard: 1,
		value: '',
		status: '',
		mandator: 'current',
		maxPerPage: 10,
		page: 1,
		sortname: 'surname',
		sortorder: 'ASC',
	}
}

function WrListe() {

	var storageKey = 'verwaltung.wrbenutzer.filter';

	var controls = {
		queryfield: $('select[name=queryfield]'),
		queryvalue: $('input[name=queryvalue]'),
		wildcard: $('input[name=wildcard]'),
		status: $('select[name=status]'),
		mandator: $('input[name=mandator]:radio'),
		maxresults: $('select[name=maxresults]'),
		reset: $('#filter_reset'),
	};

	var selectors = {
		container: '#user_container',
		indicator: '#progress-judge-list'
	};

	var filter = getOrCreateFilter();

	function newFilter() {
		return new WrFilter();
	}

	function getOrCreateFilter() {
		var filter = Storage.getPreferred().getItem(storageKey);
		if (!filter) {
			filter = newFilter();
		}
		return filter;
	}

	function saveFilterAndLoad() {
		saveFilter();
		load();
	}

	function saveFilter() {
		Storage.getPreferred().setItem(storageKey, filter);
	}

	function applyFilter() {
		controls.queryfield.val(filter.queryfield).trigger('chosen:updated');
		;
		controls.queryvalue.val(filter.value);
		if (filter.wildcard > 0) {
			controls.wildcard.prop('checked', true);
		}
		else {
			controls.wildcard.prop('checked', false);
		}
		controls.status.val(filter.status).trigger('chosen:updated');
		controls.mandator.prop('checked', false);
		controls.mandator.filter('[value=' + filter.mandator + ']').prop('checked', true);
		controls.maxresults.val(filter.maxPerPage).trigger('chosen:updated');
	}

	function load() {
		if (filter.value && filter.value.length > 0) {
			filter.queryvalue = filter.value.replace(/\*/g, '%');
			if (controls.wildcard.filter(':checked').val() > 0) {
				filter.queryvalue = '%' + filter.value + '%';
			}
		}
		else {
			filter.queryvalue = '%';
		}
		$(selectors.indicator).removeClass('hidden');
		$.get(
			'ajax_benutzer',
			{filter: JSON.stringify(filter)},
			function (data) {
				$(selectors.indicator).addClass('hidden');
				$(selectors.container).html(data);
			},
			'html'
		);
	}

	controls.queryfield.change(function () {
		filter.queryfield = $(this).val();
		if (filter.value.length > 0) {
			saveFilterAndLoad();
		}
	});
	controls.queryvalue.change(function () {
		filter.value = $(this).val();
		saveFilterAndLoad();
	});
	controls.wildcard.click(function () {
		filter.wildcard = $(this).filter(':checked').val();
		saveFilterAndLoad();
	});
	controls.status.change(function () {
		filter.status = $(this).val();
		saveFilterAndLoad();
	});
	controls.mandator.click(function () {
		filter.mandator = $(this).filter(':checked').val();
		saveFilterAndLoad();
	});
	controls.maxresults.change(function () {
		filter.maxPerPage = $(this).val();
		saveFilterAndLoad();
	});
	controls.reset.click(function (e) {
		filter = newFilter();
		applyFilter();
		saveFilterAndLoad();
		e.preventDefault();
		return false;
	});

	applyFilter();
	load();

	return {
		go: function (page) {
			filter.page = page;
			saveFilterAndLoad();
		},

		next: function () {
			filter.page++;
			saveFilterAndLoad();
		},

		previous: function () {
			filter.page--;
			saveFilterAndLoad();
		},

		sort: function (field) {
			if (filter.sortname == field) {
				this.switchSortOrder();
			}
			filter.sortname = field;
			saveFilterAndLoad();
		},

		switchSortOrder: function () {
			if (filter.sortorder == 'ASC') {
				filter.sortorder = 'DESC';
			}
			else {
				filter.sortorder = 'ASC';
			}
		}
	}
}

module.exports = WrListe;
